(function () {
	'use strict';

	angular.module('app.core')
		.directive('draggableModal', draggableModal);

	draggableModal.$inject = [];
	function draggableModal() {
		return {
			restrict: 'A',
			link: function (scope, elem, attr) {
				$(elem).parent().draggable({ handle: '.draggy' });
			}
		};
	}
})();
